var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "page-tabs mt-4" }, [
        _c(
          "a",
          {
            class: { active: _vm.currentTab === 0 },
            on: {
              click: function ($event) {
                $event.preventDefault()
                ;(_vm.currentTab = 0),
                  (_vm.tableInfo = {
                    page: 1,
                    per_page: 10,
                  })
              },
            },
          },
          [_vm._v(" 排程 ")]
        ),
        _c(
          "a",
          {
            class: { active: _vm.currentTab === 1 },
            on: {
              click: function ($event) {
                $event.preventDefault()
                ;(_vm.currentTab = 1),
                  (_vm.tableInfo = {
                    page: 1,
                    per_page: 10,
                  })
              },
            },
          },
          [_vm._v(" 同步紀錄 ")]
        ),
      ]),
      _vm.currentTab === 0
        ? [
            _c(
              "div",
              { staticClass: "yahome-table-wrap" },
              [
                _c(
                  "VueBootstrap4Table",
                  {
                    attrs: {
                      rows: _vm.rows,
                      columns: _vm.scheduleColumns,
                      config: _vm.config,
                      "total-rows": _vm.scheduleTotalData,
                    },
                    on: { "on-change-query": _vm.onChangeSchedule },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "execute",
                          fn: function (props) {
                            return [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-success btn-edit btn-sm",
                                  staticStyle: { "margin-right": "0.5rem" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.manualExecuteJob(
                                        props.row.JobType
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 立即執行 ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "setting",
                          fn: function (props) {
                            return [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-info btn-delete btn-sm",
                                  attrs: {
                                    "data-toggle": "modal",
                                    "data-target": "#settingModal",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openModal(props.row)
                                    },
                                  },
                                },
                                [_vm._v(" 排程時間設定 ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "log",
                          fn: function (props) {
                            return [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary btn-delete btn-sm",
                                  attrs: {
                                    "data-toggle": "modal",
                                    "data-target": "#recordModal",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getLogRecord(props.row.JobType)
                                    },
                                  },
                                },
                                [_vm._v(" 執行紀錄 ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "enabled",
                          fn: function (props) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  "inactive-color": "#808080",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateJobSettingEnabled(
                                      props.row
                                    )
                                  },
                                },
                                model: {
                                  value: props.row.Enabled,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "Enabled", $$v)
                                  },
                                  expression: "props.row.Enabled",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3425484243
                    ),
                  },
                  [
                    _c("template", { slot: "empty-results" }, [
                      _vm._v(" 暫無資料 "),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.currentTab === 1
        ? [
            _c("div", { staticClass: "card search-card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("同步日期"),
                        ]),
                        _c("date-picker", {
                          staticClass: "w-100",
                          attrs: {
                            type: "date",
                            range: "",
                            placeholder: "YYYY-MM-DD~YYYY-MM-DD",
                          },
                          model: {
                            value: _vm.search.dateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "dateRange", $$v)
                            },
                            expression: "search.dateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("關鍵字")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search.Keyword,
                            expression: "search.Keyword",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "請輸入關鍵字" },
                        domProps: { value: _vm.search.Keyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.search, "Keyword", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-md-2 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("同步來源")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search.Source,
                              expression: "search.Source",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.search,
                                "Source",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("全部"),
                          ]),
                          _c("option", { attrs: { value: "Email同步履歷" } }, [
                            _vm._v("Email 同步履歷"),
                          ]),
                          _c("option", { attrs: { value: "複製104履歷" } }, [
                            _vm._v("複製 104履歷"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-md-2 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [_vm._v("同步結果")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search.ExecuteResult,
                              expression: "search.ExecuteResult",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.search,
                                "ExecuteResult",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("全部"),
                          ]),
                          _c("option", { attrs: { value: "成功" } }, [
                            _vm._v("成功"),
                          ]),
                          _c("option", { attrs: { value: "失敗" } }, [
                            _vm._v("失敗"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-md-2 col-sm-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          staticStyle: {
                            "margin-top": "30px",
                            "margin-left": "10px",
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.getSyncRecord({
                                page: _vm.tableInfo.page,
                                per_page: _vm.tableInfo.per_page,
                              })
                            },
                          },
                        },
                        [_vm._v(" 查詢 ")]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "yahome-table-wrap" },
              [
                _c(
                  "VueBootstrap4Table",
                  {
                    attrs: {
                      rows: _vm.rows,
                      columns: _vm.recordColumns,
                      config: _vm.recordConfig,
                      "total-rows": _vm.recordTotalData,
                    },
                    on: { "on-change-query": _vm.onChangeQuery },
                  },
                  [
                    _c("template", { slot: "empty-results" }, [
                      _vm._v(" 暫無資料 "),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "settingModal",
            tabindex: "-1",
            "data-focus": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered" },
            [
              _c("ValidationObserver", {
                ref: "role",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-header" }, [
                              _c("span", [_vm._v("排程時間設定")]),
                            ]),
                            _c("div", { staticClass: "modal-body" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-4" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _c("span", { staticClass: "mark" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("排程設定 "),
                                    ]),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.setting.JobTimeType,
                                            expression: "setting.JobTimeType",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.setting,
                                              "JobTimeType",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { attrs: { value: "Month" } },
                                          [_vm._v("每月")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "Week" } },
                                          [_vm._v("每週")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "Day" } },
                                          [_vm._v("每日")]
                                        ),
                                      ]
                                    ),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.setting.IsRepeatPeriod,
                                            expression:
                                              "setting.IsRepeatPeriod",
                                          },
                                        ],
                                        attrs: { type: "radio", name: "timer" },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(
                                            _vm.setting.IsRepeatPeriod,
                                            false
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.setting,
                                              "IsRepeatPeriod",
                                              false
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" 執行時間 "),
                                    ]),
                                    _c("date-picker", {
                                      attrs: {
                                        type: "time",
                                        format: "HH:mm:ss",
                                        "value-type": "format",
                                        placeholder: "請選擇",
                                      },
                                      model: {
                                        value: _vm.setting.JobTimeSpan,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.setting,
                                            "JobTimeSpan",
                                            $$v
                                          )
                                        },
                                        expression: "setting.JobTimeSpan",
                                      },
                                    }),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.setting.IsRepeatPeriod,
                                            expression:
                                              "setting.IsRepeatPeriod",
                                          },
                                        ],
                                        attrs: { type: "radio", name: "timer" },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(
                                            _vm.setting.IsRepeatPeriod,
                                            true
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.setting,
                                              "IsRepeatPeriod",
                                              true
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" 重複執行每隔 "),
                                    ]),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.setting.RepeatPeriodMinute,
                                            expression:
                                              "setting.RepeatPeriodMinute",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.setting,
                                              "RepeatPeriodMinute",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "0", disabled: "" },
                                          },
                                          [_vm._v("請選擇")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "1" } },
                                          [_vm._v("1分鐘")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "3" } },
                                          [_vm._v("3分鐘")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "5" } },
                                          [_vm._v("5分鐘")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "10" } },
                                          [_vm._v("10分鐘")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "15" } },
                                          [_vm._v("15分鐘")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "30" } },
                                          [_vm._v("30分鐘")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "60" } },
                                          [_vm._v("60分鐘")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "col-md-8" }, [
                                  _vm.setting.JobTimeType === "Month"
                                    ? _c(
                                        "div",
                                        { staticClass: "month" },
                                        _vm._l(31, function (i) {
                                          return _c("label", { key: i }, [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.setting.JobDayOfMonth,
                                                  expression:
                                                    "setting.JobDayOfMonth",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: i,
                                                checked: Array.isArray(
                                                  _vm.setting.JobDayOfMonth
                                                )
                                                  ? _vm._i(
                                                      _vm.setting.JobDayOfMonth,
                                                      i
                                                    ) > -1
                                                  : _vm.setting.JobDayOfMonth,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.setting.JobDayOfMonth,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = i,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.setting,
                                                          "JobDayOfMonth",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.setting,
                                                          "JobDayOfMonth",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.setting,
                                                      "JobDayOfMonth",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v(_vm._s(i))]),
                                          ])
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm.setting.JobTimeType === "Week"
                                    ? _c(
                                        "div",
                                        { staticClass: "week" },
                                        _vm._l(_vm.week, function (i) {
                                          return _c("label", { key: i.value }, [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.setting.JobDayOfWeek,
                                                  expression:
                                                    "setting.JobDayOfWeek",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: i.value,
                                                checked: Array.isArray(
                                                  _vm.setting.JobDayOfWeek
                                                )
                                                  ? _vm._i(
                                                      _vm.setting.JobDayOfWeek,
                                                      i.value
                                                    ) > -1
                                                  : _vm.setting.JobDayOfWeek,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.setting.JobDayOfWeek,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = i.value,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.setting,
                                                          "JobDayOfWeek",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.setting,
                                                          "JobDayOfWeek",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.setting,
                                                      "JobDayOfWeek",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _c("span", [
                                              _vm._v(_vm._s(i.label)),
                                            ]),
                                          ])
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "reset",
                                    "data-dismiss": "modal",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n("Buttons.Cancel")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.updateTimeSetting)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "recordModal",
            tabindex: "-1",
            "data-focus": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered" },
            [
              _c("ValidationObserver", {
                ref: "role",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-header" }, [
                              _c("span", [_vm._v("執行紀錄")]),
                            ]),
                            _c("div", { staticClass: "modal-body" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-7 col-sm-12" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("查詢日期"),
                                        ]),
                                        _c("date-picker", {
                                          staticClass: "w-100",
                                          attrs: {
                                            "value-type": "format",
                                            format: "YYYY-MM-DD",
                                            type: "date",
                                            placeholder: "請選擇",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.getLogRecord(
                                                _vm.choiceJobType
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.logDate,
                                            callback: function ($$v) {
                                              _vm.logDate = $$v
                                            },
                                            expression: "logDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "yahome-table-wrap" },
                                      [
                                        _c(
                                          "VueBootstrap4Table",
                                          {
                                            attrs: {
                                              rows: _vm.logList,
                                              columns: _vm.logColumns,
                                              config: _vm.logConfig,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "record",
                                                  fn: function (props) {
                                                    return [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.choiceRecord(
                                                                props.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" 紀錄 ")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "empty-results" },
                                              [_vm._v("暫無資料")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-md-5 col-sm-12" },
                                  [
                                    _c("span", { staticClass: "item-type" }, [
                                      _vm._v("紀錄"),
                                    ]),
                                    _c("div", { staticClass: "item-list" }, [
                                      _vm.logRecord.Message
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.logRecord.Message)
                                            ),
                                          ])
                                        : _c("span", [_vm._v("尚未有資料")]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "reset",
                                    "data-dismiss": "modal",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n("Buttons.Cancel")) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }